import { render } from "./ItemConfirm.vue?vue&type=template&id=e744fae2&scoped=true&ts=true"
import script from "./ItemConfirm.vue?vue&type=script&lang=ts"
export * from "./ItemConfirm.vue?vue&type=script&lang=ts"

import "./ItemConfirm.vue?vue&type=style&index=0&id=e744fae2&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e744fae2"]])

export default __exports__